export default __webpack_public_path__ + "static/media/champx.c993829e.jpg";